/* Eagle Technologies - hero parallax + video controls */
(function(){
  function init(){
    document.querySelectorAll('[data-et-hero]').forEach(function(hero){
      var media = hero.querySelector('[data-et-hero-media]');
      if(media){
        var onScroll = function(){
          var r = hero.getBoundingClientRect();
          if(r.bottom < 0 || r.top > window.innerHeight) return;
          var y = Math.min(Math.max(-r.top, 0), window.innerHeight);
          media.style.transform = 'translate3d(0,' + (y * 0.18) + 'px,0) scale(1.06)';
        };
        window.addEventListener('scroll', onScroll, {passive:true});
        onScroll();
      }

      var video = hero.querySelector('video');
      var playBtn = hero.querySelector('[data-et-play]');
      var muteBtn = hero.querySelector('[data-et-mute]');
      if(!video) return;

      var PLAY = '<path d="M8 5v14l11-7z"/>';
      var PAUSE = '<path d="M6 5h4v14H6zM14 5h4v14h-4z"/>';
      var SOUND_OFF = '<path d="M3 10v4h4l5 5V5L7 10H3z"/><line x1="20" y1="5" x2="5" y2="20" stroke="currentColor" stroke-width="2"/>';
      var SOUND_ON = '<path d="M3 10v4h4l5 5V5L7 10H3zm13.5 2a4.5 4.5 0 0 0-2.5-4v8a4.5 4.5 0 0 0 2.5-4z"/>';

      if(playBtn){
        var pIcon = playBtn.querySelector('svg');
        var sync = function(){ if(pIcon) pIcon.innerHTML = video.paused ? PLAY : PAUSE; };
        playBtn.addEventListener('click', function(){
          if(video.paused){ video.play(); } else { video.pause(); }
          sync();
        });
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
        sync();
      }
      if(muteBtn){
        var mIcon = muteBtn.querySelector('svg');
        var syncM = function(){ if(mIcon) mIcon.innerHTML = video.muted ? SOUND_OFF : SOUND_ON; };
        muteBtn.addEventListener('click', function(){
          video.muted = !video.muted;
          syncM();
        });
        syncM();
      }
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
